import React from 'react';
import SearchDropdown from './SearchDropdown';
import { Form } from 'semantic-ui-react';
import Mousetrap from 'mousetrap';

class SearchFormInput extends React.Component {
  state = {}

  bindHotkey = () =>
    Mousetrap.bindGlobal('enter', this.handleAddNew);

  unbindHotkey = () =>
    Mousetrap.unbind('enter');

  componentWillUnmount = () => this.unbindHotkey();

  handleAddNew = (e) => {
    e.preventDefault();
    this.inputRef.close();
    this.props.onAddNew();
  }

  handleSubmit = () =>
    this.props.onSubmit && this.props.onSubmit();

  handleInputRef = (ref) => this.inputRef = ref;

  handleSearch = (e, data) => {
    this.props.onInputChange(e, data)
  }
  
  focusSearchInput = () => {
    this.inputRef.searchRef.focus();
  }

  render = () => {
    const {
      isFormVisible,
      onAddNew,
      onHide,
      onSubmit,
      children,
      label,
      onInputChange,
      searchValue,
      ...remainingProps
    } = this.props;
    return (
      <div>
        <Form.Input label={label}>
          <SearchDropdown
            {...remainingProps}
            searchQuery={this.props.searchValue}
            search
            selection
            ref={this.handleInputRef}
            onSearchChange={this.handleSearch}
            onOpen={this.bindHotkey}
            onClose={this.unbindHotkey}
            disabled={this.props.disabled}
            noResultsMessage={
              <span>
                Not found {this.state.search}, click
                <a onClick={this.handleAddNew} style={{cursor: 'pointer'}}> here </a>
                to add (or press <b>enter</b>)
              </span>
            }
          >
          </SearchDropdown>
        </Form.Input>
        {this.props.children}
        <div/> {/* prevents margin collapse */}
      </div>
    );
  }
}

export default SearchFormInput;



// WEBPACK FOOTER //
// ./src/component/SearchFormInput.js